import { Navigate, useLocation } from "react-router-dom";
import { isUserLoggedIn } from "./utils/helpers";

function PrivateRoute({ children }) {
  const location = useLocation();

  if (!isUserLoggedIn()) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
}
export { PrivateRoute };
